import moment from 'moment-timezone';

angular.module('ResearchKitApplicationModule').factory('surveyCompletionService', ["$http", "ceUrl", "$translate", function ($http, ceUrl, $translate) {
	function loadSurveys(patientID) {
		var url = "api/researchkit/categorizedtasks?offset=" + encodeURIComponent(moment().format("Z"));
		if (patientID) {
			url = url + "&participantID=" + patientID;
		}
		return $http.get(ceUrl.make(url)).then(function (response) {
			return response.data;
		});
	}

	function persistRestorationData(taskId, taskResult) {
		return $http.put(ceUrl.make('api/researchkit/tasks/' + taskId + '/restorationData'), taskResult).then(function (response) {
			return response.data;
		});
	}

	function deleteRestorationData(taskId) {
		return $http.delete(ceUrl.make('api/researchkit/tasks/' + taskId + '/restorationData')).then(function (response) {
			return response.data;
		});
	}

	function getConsentRestorationData(projectID, linkKey) {
		if (linkKey) {
			return $http.get(ceUrl.make('api/researchkit/studyparticipant/consentRestorationDataByLinkKey/' + linkKey)).then(function (response) {
				return response.data;
			});
		} else {
			return $http.get(ceUrl.make('api/researchkit/studyparticipant/consentRestorationData/' + projectID)).then(function (response) {
				return response.data;
			});
		}
	}

	function persistConsentRestorationData(projectID, data) {
		return $http.put(ceUrl.make('api/researchkit/studyparticipant/consentRestorationData/' + projectID), data).then(function (response) {
			return response.data;
		});
	}

	function deleteConsentRestorationData(projectID) {
		return $http.delete(ceUrl.make('api/researchkit/studyparticipant/consentRestorationData/' + projectID)).then(function (response) {
			return response.data;
		});
	}

	return {
		loadSurveys: loadSurveys,
		persistRestorationData: persistRestorationData,
		deleteRestorationData: deleteRestorationData,
		getConsentRestorationData: getConsentRestorationData,
		persistConsentRestorationData: persistConsentRestorationData,
		deleteConsentRestorationData: deleteConsentRestorationData,
	};
}]);
